import React from 'react';
import { Reveal } from '../Reveal';
import { SymbolIcon } from './SymbolIcon';

const Crop = ({ piece, crop, label }) => {
  const style = { '--fx': crop.fx, '--fy': crop.fy, '--ax': crop.ax ?? 0.5, '--ay': crop.ay ?? 0.5, '--z': crop.z };
  return (
    <figure className="apanel acrop" style={style} data-testid={`gallery-panel-${label}`}>
      <img src={crop.src || piece.image} alt={`${piece.name} — ${label} detail`} loading="lazy" draggable="false" />
      <img src={crop.srcEx || piece.imageEx} alt="" className="is-ex-layer" loading="lazy" draggable="false" aria-hidden />
    </figure>
  );
};

const Symbolism = ({ piece, isEx }) => (
  <div className="apanel asym" data-testid="gallery-panel-symbolism">
    <h2 className="asym-title" data-testid="symbolism-title">{isEx ? 'EX Symbolism' : 'Symbolism'}<span aria-hidden>✦</span></h2>
    {piece.symbolism.map((s, i) => (
      <p key={s.icon + i} className="asym-item" data-testid={`symbolism-item-${i + 1}`}>
        <SymbolIcon name={s.icon} />
        <span>{s.text}</span>
      </p>
    ))}
  </div>
);

export const ArtifactGallery = ({ piece, isEx }) => (
  <section className={`agallery ${isEx ? 'is-ex' : ''}`} data-testid="artifact-gallery">
    <Reveal>
      <div className="agallery-track">
        <Crop piece={piece} crop={piece.crops.detail} label="detail" />
        <Symbolism piece={piece} isEx={isEx} />
        <Crop piece={piece} crop={piece.crops.upper} label="upper" />
        <Crop piece={piece} crop={piece.crops.lower} label="lower" />
      </div>
    </Reveal>
  </section>
);
